var _rect, _path, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOne = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 36,
  x: 9,
  y: 2,
  fill: "#EBEBEB",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C8C8C8",
  d: "M9 29h30v7a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "M30 29V2h7a2 2 0 0 1 2 2v25z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 19.5,
  x: 1,
  y: 11,
  fill: "#1859A9",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.87 24.93q-.77 0-1.39-.25a3 3 0 0 1-1.05-.74 3.3 3.3 0 0 1-.68-1.17 5 5 0 0 1-.23-1.58q0-.88.24-1.58t.68-1.18a2.8 2.8 0 0 1 1.06-.74 3.5 3.5 0 0 1 1.37-.26q.76 0 1.38.26.62.25 1.05.73t.66 1.18q.24.69.24 1.57 0 .89-.23 1.59-.23.69-.66 1.18a2.9 2.9 0 0 1-1.05.74q-.61.25-1.39.25m-.01-1.04q1.03 0 1.56-.72.53-.73.53-1.99 0-.63-.14-1.13a2.4 2.4 0 0 0-.39-.85 1.76 1.76 0 0 0-.65-.54 2.05 2.05 0 0 0-.91-.19q-.52 0-.91.19c-.39.19-.48.307-.66.54a2.4 2.4 0 0 0-.39.85q-.13.5-.13 1.13 0 1.26.52 1.99.53.72 1.57.72m4.625-6.28h1.12l3.28 5.16v-5.16h1.18v7.14h-1.12l-3.29-5.14v5.14h-1.17zm7.1 0h4.75v1.04h-3.54v1.9h3.34v1.05h-3.34v2.11h3.73l-.14 1.04h-4.8z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOne);
export default ForwardRef;